<span class="content"><ng-content></ng-content></span>
